import { type Ref, ref } from 'vue'

import { DEFAULT_GALLERY_INDEX } from './useGalleryInteractions.constants'
import type { UseGalleryInteractionsResult } from './useGalleryInteractions.types'
import { clampToIndex } from './useGalleryInteractions.utils'

export function useGalleryInteractions(
  maxIndex: Ref<number>,
): UseGalleryInteractionsResult {
  const currentActiveIndex = ref(DEFAULT_GALLERY_INDEX)
  const mediaViewerIndex = ref(DEFAULT_GALLERY_INDEX)

  function setCurrentActiveIndex(index: number) {
    const clampedIndex = clampToIndex(index, maxIndex.value)
    currentActiveIndex.value = clampedIndex
    mediaViewerIndex.value = clampedIndex
  }

  function resetCurrentActiveIndex() {
    setCurrentActiveIndex(DEFAULT_GALLERY_INDEX)
  }

  return {
    currentActiveIndex,
    mediaViewerIndex,
    setCurrentActiveIndex,
    resetCurrentActiveIndex,
  }
}
